import './ListingsPanel.less';

export const prefix = 'bm-c-listings-panel';

export { default } from './ListingsPanel';
